import validate from 'validate.js';
import { getCountryLabelAndZones, addressFormErrors } from '../../add-a-space/data/addressFormErrors';
import { isEmpty } from 'lodash';
import postalCodes from 'postal-codes-js';

const validateBillingAddressForm = ({
  country = '',
  street = '',
  city = '',
  state = '',
  zip = ''
}, { globalCountries }) => {
  const countryLabelAndZones = getCountryLabelAndZones(globalCountries, country);

  const { selectCountry, enterStreetAddress, enterCity, selectState, enterValidPostalCode } = addressFormErrors;
  const { labels = {}, zones = [] } = countryLabelAndZones;

  const selectedCountryHasZones = !isEmpty(zones);

  validate.validators.isValidZip = (value) => {
    const zipCheck = postalCodes.validate(country, value);
    return true === zipCheck
      ? undefined
      : enterValidPostalCode[labels.postalCode || 'Postal code'];
  };

  return {
    country: validate.single(country,
      {
        presence: {
          allowEmpty: false,
          message: selectCountry
        }
      }),
    street: validate.single(street,
      {
        presence: {
          allowEmpty: false,
          message: enterStreetAddress
        }
      }),
    city: validate.single(city,
      {
        presence: {
          allowEmpty: false,
          message: enterCity[labels.city || 'City']
        }
      }),
    state: validate.single(state,
      {
        presence: {
          allowEmpty: !selectedCountryHasZones,
          message: selectState[labels.zone || 'State']
        }
      }),
    zip: validate.single(zip,
      {
        isValidZip: true
      })
  };
};

export default validateBillingAddressForm;
